export const DESKTOP_FILTERS_CONTAINER_ID = 'desktop-filters-container';
